module.exports = __webpack_public_path__ + "img/rede-familia.f78ec02c.png";